import React, { useMemo, useState, useCallback } from 'react';
import { Row, Col } from 'reactstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import SignerCoordinatesConfigurationList from './list';
import SignerCoordinatesConfigurationSelector from './selector';
import { SIGNATURE_RECTANGLE } from './constants';
import { processSignaturePosition } from "./utils"

const { WIDTH: rectangleWidth, HEIGHT: rectangleHeight } = SIGNATURE_RECTANGLE;

const generateInfiniteColors = (index) => {
  // Usamos el índice para generar valores RGB únicos
  const goldenRatio = 0.618033988749895;
  const hue = (index * goldenRatio) % 1;

  // Convertir HSV a RGB
  const h = hue * 360;
  const s = 0.7; // Saturación fija al 70%
  const v = 0.95; // Valor fijo al 95%

  const hi = Math.floor(h / 60) % 6;
  const f = h / 60 - Math.floor(h / 60);

  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);

  let r, g, b;

  switch (hi) {
    case 0:
      [r, g, b] = [v, t, p];
      break;
    case 1:
      [r, g, b] = [q, v, p];
      break;
    case 2:
      [r, g, b] = [p, v, t];
      break;
    case 3:
      [r, g, b] = [p, q, v];
      break;
    case 4:
      [r, g, b] = [t, p, v];
      break;
    case 5:
      [r, g, b] = [v, p, q];
      break;
  }

  // Convertir a valores RGB de 0-255 y agregar opacidad
  return `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)}, 0.2)`;
};


const SignerCoordinatesConfigurationContainer = props => {
  const {
    resource,
    callbacks: {
      setResource: onSetResource
    }
  } = props;


  const signers = useMemo(() => {
    const activeSigners = resource.signers.filter(signer => !signer._destroy && !signer.hide_signature_image);
    let accumulatedDeltaY = 10;

    return _.map(activeSigners, (signer, index) => {
      if (_.isEmpty(signer.sign_coordinates)) {
        const { x: adjustedX, y: adjustedY } = processSignaturePosition({
          currentX: 0,
          currentY: 0,
          deltaX: resource.document_information.pages[0].size.width,
          deltaY: accumulatedDeltaY,
          width: rectangleWidth,
          height: rectangleHeight,
          pageDimensions: resource.document_information.pages[0].size,
          existingSignatures: resource.document_information.pages[0]?.signatures || [],
        });

        signer.sign_coordinates = {
          x: adjustedX,
          y: adjustedY,
          page_number: 1
        };

        accumulatedDeltaY = adjustedY + rectangleHeight;
      }

      return {
        ...signer,
        color: generateInfiniteColors(index)
      };
    });
  }, [resource.signers])

  const onChangeCurrentSignerCustomerId = useCallback((customId) => {
    setCurrentSignerCustomId(customId);
  }, [])

  const [currentSignerCustomId, setCurrentSignerCustomId] = useState(null);

  return (
    <Row>
      <Col>
        <SignerCoordinatesConfigurationList
          signers={signers}
          currentSignerCustomId={currentSignerCustomId}
          callbacks={{
            onChangeCurrentSignerCustomerId
          }}
        />
      </Col>

      <DndProvider backend={HTML5Backend}>
        <Col>
          <SignerCoordinatesConfigurationSelector
            resource={resource}
            signers={signers}
            currentSignerCustomId={currentSignerCustomId}
            callbacks={{
              onSetResource: onSetResource,
              onChangeCurrentSignerCustomerId: onChangeCurrentSignerCustomerId
            }}
          />
        </Col>
      </DndProvider>
    </Row>
  )
}

export default SignerCoordinatesConfigurationContainer;
